<div class="d-flex justify-content-between">
  <div class="back" (click)="GoToMyTabs(0)"><i class="fa fa-chevron-left" aria-hidden="true"></i><i
      class="fa fa-chevron-left" aria-hidden="true"></i> Back</div>
  <!-- <ng-container *ngIf="profileInfo?.isVerified">
    <a class="reset-passcode" (click)="openVerificationPopup()"> {{ showVerification ? 'Profile Setting' : 'Reset
      Passcode' }} </a>
  </ng-container> -->
  <a class="reset-passcode" routerLink="/advanced-settings">Advanced Settings</a>
</div>

<ng-container *ngIf="!showVerification">
  <div class="form-group mb-1 text-left">
    <label class="mb-0">Character Name</label>
    <input placeholder="Enter Character Name" class="form-control" [(ngModel)]="charName" />
  </div>
  <div class="form-group mb-1 text-left">
    <label class="mb-0">Postal Code</label>
    <input placeholder="123456" class="form-control" [(ngModel)]="postalCode" minlength="6" maxlength="6"
      (ngModelChange)="filterSubregions()" />
  </div>
  <div class="form-group mb-1 text-left">
    <label class="mb-0">Short Description</label>
    <textarea placeholder="" class="form-control" [(ngModel)]="shortDescription" class="form-control"></textarea>
  </div>

  <div class="form-group mb-1 text-left">
    <label class="mb-0">Region</label>
    <app-multi-dropdown [placeholder]="selectedMemberRegion" [items]="regionList" (itemSelected)="onRegionClick($event)"
      title="Select postal code to change region" [disabled]="true"></app-multi-dropdown>
  </div>

  <ng-container *ngIf="roleService?.roles">
    <div class="form-group mb-1 text-left" *ngIf="roleService.roles?.users?.includes('MEMBER_CERTIFIED')">
      <label class="mb-0">Certified</label>
      <select2 [data]="certifiedSelect" [multiple]="true" displaySearchStatus="always" ngDefaultControl
        (update)="updateCertificate($event)" [value]="certifiedValue"> </select2>
    </div>
  </ng-container>

  <!-- <div class="form-group mb-1 text-left">
    <label class="mb-0">Email</label>
    <input type="email" placeholder="Enter Email" class="form-control" [(ngModel)]="email" />
    <button *ngIf="!isEmailVerify && this.email == this.currentEmail" class="btn btn-secondary mt-2" (click)="handleOTPVerification(VerifyEmailOtp)"><i class="fa fa-envelope"></i> Verify Email</button>
  </div> -->

  <div class="form-group mb-1 text-left" *ngIf="roleService.roles?.level?.includes('MEMBER_SHOP_THEME')">
    <label class="mb-0">Theme</label>
    <select class="form-control" [value]="selectedTheme" (change)="onThemeChange($event)">
      <option value="space">Space</option>
      <option value="beige">Beige</option>
      <option value="winter">Winter</option>
      <option value="bronze">Bronze</option>
    </select>
  </div>

  <!-- <div class="form-group mb-0">
    <div class="form-check">
      <input class="form-check-input" type="checkbox" name="buyerContact" [(ngModel)]="buyerContact" id="defaultCheck1" />
      <label class="form-check-label" for="defaultCheck1"> Don’t let buyer text u directly </label>
    </div>
  </div>
  <div class="form-group">
    <div class="form-check">
      <input class="form-check-input" type="checkbox" name="tutorial" [checked]="tutorials" (change)="onTutorialsChange($event)" id="defaultCheck2" />
      <label class="form-check-label" for="defaultCheck2">Tutorial</label>
    </div>
  </div>

  <div class="bottom-info">
    <div class="bottom-info__verified" style="display: flex; justify-content: flex-start; flex-direction: column; align-items: flex-start">
      <div>
        <i class="fa-brands fa-whatsapp"></i> WhatsApp:
        <button class="btn" (click)="profileInfo?.isVerified ? '' : (showVerificationTelegram = true)">
          <i
            class="fa fa-check-circle"
            [ngStyle]="{
              color: profileInfo?.isVerified ? 'green' : 'red'
            }"
          ></i>
          {{ profileInfo?.isVerified ? "" : "Not" }}
          Verified
        </button>
      </div>
      <div (click)="getTelegramLinks()">
        <i class="fa-brands fa-telegram"></i> Telegram:
        <i
          class="fa fa-check-circle"
          [ngStyle]="{
            color: profileInfo?.isTelegramVerified ? 'green' : 'red'
          }"
        ></i>

        <button *ngIf="profileInfo?.isTelegramVerified" class="btn">Verified</button>

        <a [href]="'https://t.me/kachiing_sg_bot?start=verify' + telegramLink" *ngIf="!profileInfo?.isTelegramVerified">
          <button class="btn">Not Verified</button>
        </a>
      </div>
    </div>
  </div>

  <div class="verification" *ngIf="showVerificationTelegram" [ngClass]="{ active: showVerificationTelegram }">
    <span (click)="showVerificationTelegram = false; isReset = false">
      <i class="fa-solid fa-times" style="color: black !important"></i>
    </span>
    <div>
      <div style="display: flex; justify-content: center; align-items: center">
        <mat-label>Enter OTP</mat-label>
        <mat-form-field style="width: 100%; display: flex; align-items: center; gap: 10px">
          <input matInput formControlName="otp" maxlength="6" style="text-align: center" class="form-control" (change)="onChangeOtp($event)" required />
          <button mat-raised-button color="primary" (click)="sendOtp()" [disabled]="isLoading" style="margin-bottom: 10px" class="btn btn-purple">OTP</button>
        </mat-form-field>
      </div>

      <mat-form-field style="width: 100%; display: flex; flex-direction: column">
        <mat-label class="mb-2 mt-2">Enter 4 Digit Passcode</mat-label>
        <input matInput formControlName="otp" maxlength="4" style="text-align: center" class="form-control mb-2" (change)="onChangePasscode($event)" required />
      </mat-form-field>
      <div style="color: red">{{ otpError }}</div>
      <button (click)="verifyOtp()" [disabled]="isLoading" class="btn btn-purple mt-2">Verify</button>
    </div>
  </div> -->

  <div>
    <button class="btn btn-primary my-2 w-100" style="background-color: var(--primary); border: none"
      (click)="saveProfileInfo()"><i class="fa-solid fa-save"></i> Save</button>
  </div>
</ng-container>
<div class="verificationPopup" *ngIf="showVerification">
  <div>
    <div class="form-group">
      <label for="">New Passcode</label>
      <input type="password" class="form-control" [(ngModel)]="passcode" placeholder="New Passcode" />
    </div>
    <div class="form-group">
      <label for="">New Passcode Confirmation</label>
      <input type="password" class="form-control" [(ngModel)]="passcodeConfirm"
        placeholder="New Passcode Confirmation" />
    </div>
    <div class="form-group">
      <label for="">Enter OTP</label>
      <div class="d-flex gap-2">
        <input type="number" minlength="6" maxlength="6" [(ngModel)]="otp" class="form-control"
          (keyup)="$event.target.value = $event.target.value.substr(0, 6)" placeholder="XXXXXX" />
        <button class="btn btn-dark text-nowrap" (click)="handleSendOTP()">
          Send OTP<span *ngIf="delaySendOTP > 0" class="ml-2">({{ delaySendOTP }})</span>
        </button>
      </div>
    </div>

    <button class="btn btn-primary mt-2 w-100" style="background-color: var(--primary); border: none"
      (click)="handleVerify()"><i class="fa-solid fa-save"></i> Verify</button>
  </div>
</div>

<ng-template #VerifyEmailOtp let-modal>
  <div class="modal-body">
    <div class="add_cattt d-flex justify-content-between">
      <h2>Verify Email OTP</h2>
      <img loading="lazy" src="../../../assets/images/close-icon.svg" alt="img"
        (click)="modal.dismiss('Cross click')" />
    </div>
    <div class="referral-link">
      <section class="m-4">
        <div class="form-group">
          <input placeholder="Enter OTP" type="text" name="selectedMemberPassword" pattern="\d*" maxlength="6" autofocus
            class="otp-input w-100" [(ngModel)]="selectedOTP" required />
        </div>
        <p class="error-message p-0" *ngIf="invalidOtp">{{ invalidOtp }}</p>
      </section>
      <div class="mt-4">
        <div class="cart_btn">
          <button class="com_btn add-review-btn px-2" (click)="verifyEmailOtp()">Verify <i class="fa fa-thumbs-up"
              aria-hidden="true"></i></button>
        </div>
      </div>
    </div>
  </div>
</ng-template>